import React from 'react'
import ContactCarousal from './contactCarousal'
import { useContext } from 'react'
import NoteContext from '../context/notes/noteContext'
export default function ContactUs() {
    const context = useContext(NoteContext)
        const {setBars} = context
        setBars('white-bars')
    return (
        <div>
            <ContactCarousal />
            <div className="container">
                <div className="row">
                    <div className="col-md-6 col-12">

                        <div className='mx-3 mt-3 py-3'>
                            <div className="mb-3">
                                <div className="d-flex m-2 flex-column">
                                    <p style={{fontSize:"26px",color:'#333',fontWeight:'bold'}} className='mx-2'>Contact Us</p>
                                    <p className='mx-2' style={{ color: '#777' }}>Call or submit our online form to request an estimate or for general questions about U.S. Certified Contractors and our services. We look forward to serving you!</p>
                                </div>
                            </div>
                            <div class="mb-3">
                                <div className="d-flex m-2">
                                    <input style={{borderRadius:'0px'}} type="text" placeholder="First Name *" class="form-control mx-2" id="exampleFormControlInput1" />
                                    <input style={{borderRadius:'0px'}} type="text" placeholder="First Name *" class="form-control" id="exampleFormControlInput1" />
                                </div>
                                <div className="d-flex m-2">
                                    <input style={{borderRadius:'0px'}} type="text" placeholder="Your Email *" class="form-control mx-2" id="exampleFormControlInput1" />
                                    <input style={{borderRadius:'0px'}} type="text" placeholder="Your Phone Number *" class="form-control" id="exampleFormControlInput1" />
                                </div>
                            </div>
                            <div className="mb-3">
                                <div className="d-flex m-2">
                                    <input style={{borderRadius:'0px'}} type="text" placeholder="Subject" class="form-control mx-2" id="exampleFormControlInput1" />
                                </div>
                            </div>
                            <div class="mb-3">
                                <div className="d-flex m-2">

                                    <textarea style={{borderRadius:'0px'}} placeholder='Message' class="form-control mx-2" id="exampleFormControlTextarea1" rows="3"></textarea>
                                </div>
                            </div>
                            <div class="mb-3">
                                <div className="d-flex m-2">

                                    <button className="btn mx-2" style={{backgroundColor:'#A10302',color:'white',borderRadius:'0px'}}>Submit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-12">
                        <div className="m-5 py-5">
                            <div className="row">
                                <div className="col-md-6 col-12">
                                    <p style={{fontSize:'18px',color:'#333'}} >MAILING ADDRESS</p>
                                    <p style={{fontSize:'14px',color:'#777'}}>
499 Hwy 71w suite 200 bastrop TX 78602</p>
                                </div>
                                <div className="col-md-6 col-12">
                                    <p  style={{fontSize:'18px',color:'#333'}}>CONTACT INFO</p>
                                    <p  style={{fontSize:'14px',color:'#777'}}>512 923 9756 <br />
                                        contact@moabbuilders.com</p>
                                </div>

                            </div>
                            <div class="mapouter"><div class="gmap_canvas"><iframe class="gmap_iframe" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?width=600&amp;height=400&amp;hl=en&amp;q=University of Oxford&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"></iframe><a href="https://www.gachacute.com/">Download</a></div></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/contactUs.jsx